import { AxiosResponse } from 'axios';
import { useAuth } from 'core/contexts';
import {
    withHeaders,
    instance as axiosInstance,
} from 'core/util/axiosInstance';
import { getDefaultHeaders } from 'core/util/other';
import { useQuery, UseQueryResult } from 'react-query';

interface StepType {
    type: string;
}

const getStepTypeData = async (
    url: string,
    token: string
): Promise<AxiosResponse<any[], any>> => {
    const headers = getDefaultHeaders(token);
    const response = await axiosInstance().get(url, withHeaders(headers));
    return response;
};

export const useStep = ({
    type,
}: StepType): UseQueryResult<AxiosResponse<any[], any>, unknown> => {
    const { getToken } = useAuth();
    const url = `/metadata/datapipeline/steps/${type}`;

    return useQuery(url, async () => getStepTypeData(url, getToken()), {
        enabled: !!type,
    });
};
